import React from 'react'
import MedalIcon from '../../../assets/icons/medal.svg?react'

type Props = {  size?: 'sm' | 'md', hideIcon?: boolean, hideLabel?: boolean }
const PremiumTag: React.FC<Props> = ({ size = 'md', hideIcon, hideLabel }) => {
  const sizeClasses = size === 'sm' ? 'text-[8px] md:text-3xs p-0.5' : 'text-2xs md:text-xs px-1 md:px-2 py-1'
  return (
    <span className={`${sizeClasses} gap-x-1 inline-flex items-center font-semibold text-orange rounded-md border border-solid border-orange bg-white`}>
      {!hideIcon && <MedalIcon className='fill-orange' />}{!hideLabel && <div>BLOOM PRO</div>}
    </span>
  )
}

export default PremiumTag
